import { GetState } from '@store/store';

export const toJobServiceEndpoint = (getState: GetState) => {
  const {
    config: { endpoints }
  } = getState();

  return endpoints.jobService;
};
